module.exports = __webpack_public_path__ + "img/Airbnb-Working-On-the-Move-Ergo-Anywhere3-700x334.69a9923c.png";